module.exports = __webpack_public_path__ + "img/popup_frame.e6c84867.png";